module.exports = __webpack_public_path__ + "static/media/alerta-gps-rojo.56fd4e82.svg";